"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobileDesktop_1 = __importDefault(require("./mobileDesktop"));
var newReturning_1 = __importDefault(require("./newReturning"));
var currentPage_1 = __importDefault(require("./currentPage"));
var trafficSource_1 = __importDefault(require("./trafficSource"));
var pagesVisited_1 = __importDefault(require("./pagesVisited"));
var queryParameter_1 = __importDefault(require("./queryParameter"));
var cookie_1 = __importDefault(require("./cookie"));
var subscriber_1 = __importDefault(require("./subscriber"));
var campaignEngagement_1 = __importDefault(require("./campaignEngagement"));
var mobileIdentity_1 = __importDefault(require("./mobileIdentity"));
var croct_1 = __importDefault(require("./croct"));
var TargetCheckerDict = {
    mobileDesktop: mobileDesktop_1.default,
    trafficSource: trafficSource_1.default,
    newReturning: newReturning_1.default,
    pagesVisited: pagesVisited_1.default,
    queryParameter: queryParameter_1.default,
    currentPage: currentPage_1.default,
    cookie: cookie_1.default,
    subscriber: subscriber_1.default,
    campaignEngagement: campaignEngagement_1.default,
    mobileIdentity: mobileIdentity_1.default,
    croct: croct_1.default
};
exports.default = TargetCheckerDict;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic3JjL2xpYi9zZXJ2aWNlcy90YXJnZXRzL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBRUEsa0VBQTJDO0FBQzNDLGdFQUF5QztBQUN6Qyw4REFBdUM7QUFDdkMsa0VBQTJDO0FBQzNDLGdFQUF5QztBQUN6QyxvRUFBNkM7QUFDN0Msb0RBQTZCO0FBQzdCLDREQUFxQztBQUNyQyw0RUFBcUQ7QUFDckQsb0VBQTZDO0FBRTdDLGtEQUEyQjtBQVUzQixJQUFNLGlCQUFpQixHQUE0QjtJQUMvQyxhQUFhLHlCQUFBO0lBQ2IsYUFBYSx5QkFBQTtJQUNiLFlBQVksd0JBQUE7SUFDWixZQUFZLHdCQUFBO0lBQ1osY0FBYywwQkFBQTtJQUNkLFdBQVcsdUJBQUE7SUFDWCxNQUFNLGtCQUFBO0lBQ04sVUFBVSxzQkFBQTtJQUNWLGtCQUFrQiw4QkFBQTtJQUNsQixjQUFjLDBCQUFBO0lBQ2QsS0FBSyxpQkFBQTtDQUNSLENBQUE7QUFFRCxrQkFBZSxpQkFBaUIsQ0FBQSJ9